export class PatBemModel {
 patBemId? :number =  0;
 patTipoBemId? :number =  0;
 codigo? :string =  '';
 descricao? :string =  '';
 observacao? :string =  '';
 dataAquisicao?: Date | undefined = undefined;
 valorAquisicao? :number =  0;
 notaFiscal? :string =  '';
 patEstadoConservacaoId? :number =  0;
 patFormaTombamentoId? :number =  0;
 unidadeGuarda? :string =  '';
 vidaUtil? :number =  0;
 quantidade? :number =  0;
 formaAquisicao? :number =  0;
 gesFornecedorId? :number =  0;
 gesEscolaId? :number =  0;
 gesSalaId? :number =  0;
 localizacao? :string =  '';
 situacao? :number =  0;
 dataBaixa?: Date | undefined = undefined;
 patMotivoBaixaId? :number =  0;
 motivoBaixa? :string =  '';
 termoDoacao? :string =  '';
 valorResidual? :number =  0;
 patTipoBemDescricao? :string =  '';
 patEstadoConservacaoDescricao? :string =  '';
 patMotivoBaixaDescricao? :string =  '';
 salaDescricao? :string =  '';
}
